import { render, staticRenderFns } from "./footerLayout.vue?vue&type=template&id=1f701bc0&scoped=true&"
import script from "./footerLayout.vue?vue&type=script&lang=js&"
export * from "./footerLayout.vue?vue&type=script&lang=js&"
import style0 from "./footerLayout.vue?vue&type=style&index=0&id=1f701bc0&scoped=true&lang=css&"
import style1 from "./footerLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f701bc0",
  null
  
)

export default component.exports